/**
 * RN Hero Split - Video Controls
 * Handles play/pause and mute/unmute for uploaded videos
 */

(function() {
  'use strict';

  function initHeroSplitVideos() {
    // Support both class names for backwards compatibility
    const sections = document.querySelectorAll('.rn-hero, .rn-hero-split-section, [class*="rn-hero"]');

    sections.forEach(section => {
      const videoWrapper = section.querySelector('.rn-hero__video-wrapper');
      if (!videoWrapper) return;

      const videoType = videoWrapper.dataset.videoType;

      // Only handle uploaded videos (external videos are controlled via iframe params)
      if (videoType !== 'uploaded') return;

      const video = videoWrapper.querySelector('video.rn-hero__video');
      const playBtn = videoWrapper.querySelector('.rn-hero__video-play');
      const muteBtn = videoWrapper.querySelector('.rn-hero__video-mute');

      if (!video) return;

      // Play button functionality
      if (playBtn) {
        playBtn.addEventListener('click', function() {
          if (video.paused) {
            video.play();
            playBtn.classList.add('is-hidden');
          } else {
            video.pause();
            playBtn.classList.remove('is-hidden');
          }
        });

        // Show play button again when video ends (if not looping)
        video.addEventListener('ended', function() {
          if (!video.loop) {
            playBtn.classList.remove('is-hidden');
          }
        });

        // Hide play button when video starts playing
        video.addEventListener('play', function() {
          playBtn.classList.add('is-hidden');
        });

        // Show play button when video pauses
        video.addEventListener('pause', function() {
          if (!video.ended) {
            playBtn.classList.remove('is-hidden');
          }
        });
      }

      // Mute button functionality
      if (muteBtn) {
        muteBtn.addEventListener('click', function() {
          video.muted = !video.muted;
          muteBtn.dataset.muted = video.muted.toString();
        });

        // Sync mute state if user changes via native controls
        video.addEventListener('volumechange', function() {
          muteBtn.dataset.muted = video.muted.toString();
        });
      }

      // Force autoplay on mobile - must be muted for autoplay to work
      if (video.autoplay || video.hasAttribute('autoplay')) {
        // Ensure video is muted for autoplay policy compliance
        video.muted = true;
        video.playsInline = true;

        // Try to play immediately on load
        const attemptPlay = () => {
          const playPromise = video.play();
          if (playPromise !== undefined) {
            playPromise.catch(() => {
              // Autoplay failed - show play button if it exists
              if (playBtn) {
                playBtn.classList.remove('is-hidden');
              }
            });
          }
        };

        // Attempt autoplay immediately
        if (video.readyState >= 2) {
          attemptPlay();
        } else {
          video.addEventListener('loadeddata', attemptPlay, { once: true });
          video.addEventListener('canplay', attemptPlay, { once: true });
        }

        // Also use Intersection Observer for videos that scroll in/out of view
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                attemptPlay();
              } else {
                video.pause();
              }
            });
          },
          { threshold: 0.25 }
        );

        observer.observe(video);
      }
    });
  }

  // Initialize on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeroSplitVideos);
  } else {
    initHeroSplitVideos();
  }

  // Re-initialize when Shopify section is re-rendered (theme editor)
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.classList.contains('rn-hero-split-section') ||
        event.target.classList.contains('rn-hero') ||
        event.target.querySelector('.rn-hero')) {
      initHeroSplitVideos();
    }
  });
})();
